import { DeleteLinkButton, OverviewHeader } from "components";
import { CreateCampaignButton } from "./CreateCampaignButton";
import { DuplicateButton } from "components/buttons/linkButtons/headerButtons/DuplicateButton";
import { Tooltip } from "components/common/tooltip";
import { ContentTypesEnum, RolePermissions, Strings } from "enums";
import { Icon } from "semantic-ui-react";
import Restricted from "features/Application/Restricted";

type Props = {
  showActionButtons?: boolean;
  onDuplicate: () => void;
  selectedItemsCount: number;
  deleteDisabled: boolean;
  onDelete: () => void;
};

export const CampaignsOverviewHeader = ({
  showActionButtons = false,
  onDuplicate,
  selectedItemsCount,
  onDelete,
  deleteDisabled,
}: Props) => {
  return (
    <OverviewHeader
      title="Campaigns"
      itemName={"Campaign"}
      titleForGA="Phishing Campaigns"
      selectedItemsAmount={selectedItemsCount}
    >
      <Restricted
        permissions={[RolePermissions.CampaignsManage]}
        renderContent={(hasAnyPermission: boolean) => (
          <>
            {showActionButtons ? (
              <>
                <DuplicateButton entityName={"Campaign"} purchasedSelected={false} onClick={onDuplicate} />
                <Tooltip
                  showAlways={deleteDisabled}
                  inverted
                  hideOnScroll
                  position="left center"
                  target={
                    <DeleteLinkButton
                      after={deleteDisabled && <Icon size="large" className="fa fa-exclamation-circle" />}
                      isDisabled={deleteDisabled || !hasAnyPermission}
                      onClick={onDelete}
                    />
                  }
                  content={Strings.tooltipMessages.purchased.deleteDisabled(ContentTypesEnum.Campaigns)}
                />
              </>
            ) : (
              <CreateCampaignButton />
            )}
          </>
        )}
      />
    </OverviewHeader>
  );
};
